import React from 'react'

import Tooltip from '../tooltip/Tooltip'
import { translate } from '../../utils/translation'
import downloadIcon from '../../styles/assets/download.svg'

export const ExportIcon = ({ distance, size = 25 }) => (
  <Tooltip
    textStyle={{
      minWidth: 'fit-content',
      padding: '5.6px 0',
    }}
    style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '3px',
    }}
    text={translate('export_pdf')}
    content={
      <img src={downloadIcon} width={size} height={size} alt="download icon" />
    }
    place="top"
    offset={-100}
    distance={distance}
  />
)
